module.exports = __webpack_public_path__ + "static/banner.founder-eaf68ffaf5de1c896965a48d77bb3e68.png";